var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("rect", { id: "a", width: "20", height: "20", rx: "10" })
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement(
        "mask",
        { id: "b", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#a" })
      ),
      React.createElement("use", { fill: "#FFE403", xlinkHref: "#a" }),
      React.createElement("path", { d: "M10.582 8.85c.153.05.288.089.418.14.902.354 1.497 1 1.793 1.919.059.183.07.382.102.574.013.082-.032.113-.106.113l-1.248.001c-.108 0-.13-.075-.142-.158a1.283 1.283 0 0 0-.485-.843c-.866-.689-2.142-.266-2.4.803-.185.765.271 1.497.995 1.736.639.21 1.476-.098 1.752-.72.04-.091.106-.095.187-.07l1.136.363c.11.035.126.069.085.173a2.45 2.45 0 0 1-.487.79c-.707.748-1.576 1.1-2.598.969-1.08-.14-1.868-.723-2.325-1.716-.346-.75-.329-1.515-.047-2.29.254-.695.478-1.401.715-2.103.249-.736.498-1.472.745-2.208.25-.739.498-1.478.744-2.218.03-.09.066-.127.164-.093.33.115.663.227.996.336.08.026.1.06.072.143-.23.674-.455 1.349-.68 2.023l-.569 1.707c-.005.016-.008.033.007.061.078-.11.157-.218.234-.328.54-.77 1.08-1.538 1.618-2.31.058-.083.106-.097.193-.035.27.194.545.38.817.57.114.08.117.102.035.218l-1.655 2.35c-.02.028-.038.058-.066.103", fill: "#000", mask: "url(#b)" })
    )
  );
});